import { useLightboxContext } from "@sphtech/idpf-lightbox-react";
import { PublicationShortname } from "@src/app/auth/serviceIdentifier";
import type { ReactElement } from "react";
import logoutIcon from "src/app/assets/icons/logout.svg";
import { clearLoginSession } from "src/trackers/viewerContext";

import styles from "./index.module.scss";

type Props = {
  theme: PublicationShortname;
  handleLogout: () => void;
  label: string;
};

export default function LogoutButton({
  theme,
  handleLogout,
  label,
}: Props): ReactElement {
  const { lightbox } = useLightboxContext();

  const onLogout = () => {
    // Cleanup BEFORE initiateLogout — a redirect happens during logout
    clearLoginSession(theme);
    handleLogout();

    lightbox?.initiateLogout();
  };

  return (
    <button
      className={styles.logoutButton}
      onClick={onLogout}
      data-theme={theme}
    >
      <img src={logoutIcon} alt="" />
      <span className={styles.label}>{label}</span>
    </button>
  );
}
